import {Pipe, PipeTransform} from '@angular/core';
import {DataPoint} from '@selpia/shared/models';

@Pipe({standalone: true, name: 'dataPointMatch'})
export class DatapointMatchesPipe implements PipeTransform {
  transform(
    value: DataPoint | undefined,
    matchingIds: number[],
  ): boolean {
    return (!!value && matchingIds.includes(value.id));
  }
}
